module.exports = __webpack_public_path__ + "assets/icon-close-pc-7936f246.png";